import { NgModule, enableProdMode } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { environment } from "../environments/environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AuthModule } from "./auth/auth.module";
import { CoreModule } from "./core/core.module";
import { PlatformModule } from "./platform/platform.module";
import { MessagingModule } from "./shared/messaging/messaging.module";
import { DevControlsModule } from "./zdevcontrols/zdevcontrols.module";

const developmentModules = [];
if (environment.production) {
  enableProdMode();
} else {
  // developmentModules.push(ToolboxModule);
  // developmentModules.push(DevControlsModule); // TODO: Remove this module from production build.
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    AppRoutingModule,
    DevControlsModule,
    ...developmentModules,
    BrowserModule,
    CoreModule,
    PlatformModule,
    AuthModule,
    FormsModule,
    BrowserAnimationsModule,
    // OnboardingModule,
    MessagingModule,
    FontAwesomeModule,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
